import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsPanelComponent } from './notifications-panel.component';
import {DxButtonModule, DxContextMenuModule, DxListModule, DxPopoverModule, DxScrollViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [NotificationsPanelComponent],
  imports: [
    CommonModule,
    DxButtonModule,
    DxPopoverModule,
    DxScrollViewModule,
    DxListModule,
    DxContextMenuModule
  ],
  exports: [NotificationsPanelComponent]
})
export class NotificationsPanelModule { }
